/**
 * Modul-Keys aus dem worksuite-admin, die work-office für Navigation und Routen prüft
 * (`data.requiredModule` an der Route). Die Freischaltungen stehen vorerst nur Axova offen.
 */
export enum WorksuiteModuleKeyEnum {
  Artikelkatalog = 'artikelkatalog',
  Akquise = 'akquise',
  Geruestbau = 'geruestbau',
  ElektroDrittkontrolle = 'elektroDrittkontrolle',
  Seriennummern = 'seriennummern',
  SensDeklaration = 'sensDeklaration',
  FinanzControlling = 'finanzControlling',
  WebsiteTags = 'websiteTags',
  Connectors = 'connectors',
  Belegerfassung = 'belegerfassung',
  Akquiseobjekte = 'akquiseobjekte',
  Chat = 'chat',
}
